/**
 * Shared constants for standalone custom-task action routing.
 *
 * Extracted so unit tests can import them directly without rendering
 * the full React components (UpNextCardV2, FollowUpV2).
 *
 * STANDALONE_ACTIONABLE_TYPES — item_types that have a real action panel.
 *   Used by UpNextCardV2 to decide whether to show the primary "Take action"
 *   button. A method-less standalone task (STANDALONE_TASK) has no panel to
 *   open so its button is hidden.
 *
 * ITEM_TYPE_TO_CHANNEL — maps item_type → FollowUpPanel initialChannel value.
 *   Used by FollowUpV2.handleActionClick to seed FollowUpPanel so it opens
 *   directly at the method sub-panel, bypassing the 4-card channel picker.
 */

/** item_types for which standalone tasks have an actionable panel. */
export const STANDALONE_ACTIONABLE_TYPES = new Set(['WHATSAPP_SENT', 'EMAIL_SENT', 'LOG_PHONE_CALL']);

/**
 * Maps an item_type to the FollowUpPanel `initialChannel` prop value.
 * Returns undefined for unmapped types — callers fall back to `null`.
 */
export const ITEM_TYPE_TO_CHANNEL = {
    EMAIL_SENT:    'email',
    WHATSAPP_SENT: 'whatsapp',
    LOG_PHONE_CALL: 'call',
};
